import config from '../package.json';

const ID = `${config.name}/actions/partnersAction`;
const createActionName = (name: string) => `app/${ID}/${name}`;

export const REDIRECT_ACTION = createActionName('REDIRECT_ACTION');
export const REDIRECT_READY = createActionName('REDIRECT_READY');
export const IS_WINDOWS_REDAY_CHECK = createActionName('REDIRECT_READY');
